import React from 'react';
import { render } from 'react-dom';
import { Provider } from "react-redux";
import getRoutes from './routes/routes.jsx';
import store from './store';

render((
    <Provider store={store}>
        {getRoutes()}
    </Provider>
), document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./app/index.jsx
 **/